var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconMultiselectAdd(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Assets",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "assets",
    transform: "translate(-625.000000, -1051.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "components/buttons/newplaylist/create-playlist-1",
    transform: "translate(625.000000, 1051.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "components/buttons/create-playlist-1"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#23AD1A",
    cx: 12,
    cy: 12,
    r: 12
  }), /*#__PURE__*/React.createElement("g", {
    id: "icon/Save"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "bound",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.65,10.25 L18.025,10.25 C18.5082492,10.25 18.9,10.6417508 18.9,11.125 L18.9,12.875 C18.9,13.3582492 18.5082492,13.75 18.025,13.75 L13.65,13.75 L13.65,18.125 C13.65,18.6082492 13.2582492,19 12.775,19 L11.025,19 C10.5417508,19 10.15,18.6082492 10.15,18.125 L10.15,13.75 L5.775,13.75 C5.29175084,13.75 4.9,13.3582492 4.9,12.875 L4.9,11.125 C4.9,10.6417508 5.29175084,10.25 5.775,10.25 L10.15,10.25 L10.15,5.875 C10.15,5.39175084 10.5417508,5 11.025,5 L12.775,5 C13.2582492,5 13.65,5.39175084 13.65,5.875 L13.65,10.25 Z",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "evenodd"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMultiselectAdd);
export default __webpack_public_path__ + "static/media/iconMultiselectAdd.74cac08a.svg";
export { ForwardRef as ReactComponent };